import { render, staticRenderFns } from "./RetangularButton.vue?vue&type=template&id=c4c4bd7c&scoped=true&"
import script from "./RetangularButton.vue?vue&type=script&lang=js&"
export * from "./RetangularButton.vue?vue&type=script&lang=js&"
import style0 from "./RetangularButton.vue?vue&type=style&index=0&id=c4c4bd7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c4bd7c",
  null
  
)

export default component.exports